// React
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Components
import { MpsOrderFailure } from '@mobilitystore/components-interface';

// Assets
import { imageLink } from '../../../../assets/img';

// CSS
import './index.scss';

const OrderFailure = () => {
  const history = useHistory();
  const content = useSelector((state) => state.ContentReducer?.content);

  const orderFailureContent = content?.components?.order_failure;

  const button = {
    mode: 'primary',
    label: orderFailureContent?.buttons?.label,
    onClick: () => {
      history.push('/dashboard/place-order');
    }
  };

  const orderFailureIcon = {
    image: `${imageLink}/${orderFailureContent?.images?.icon?.image}`,
    alt: `${orderFailureContent?.images?.icon?.alt}`
  };

  const orderFailureIllustration = {
    image: `${imageLink}/${orderFailureContent?.images?.illustration?.image}`,
    alt: `${orderFailureContent?.images?.illustration?.alt}`
  };

  return (
    <MpsOrderFailure
      orderFailureIcon={orderFailureIcon}
      title={orderFailureContent?.title}
      description={orderFailureContent?.description}
      orderFailureIllustration={orderFailureIllustration}
      button={button}
    />
  );
};

export default OrderFailure;
